import { useQuery } from '@apollo/client/react/hooks';
import { logError } from 'fergy-core-react-logging';
import { type FunctionComponent, useState } from 'react';
import { type ProjectRoomsQuery, type ProjectRoomsQueryVariables } from '../../../__generated__/graphql-client-types';
import { PROJECT_ROOMS } from '../../../queries/project/project.queries';
import { Loading } from '../../common-components/loading/loading.component';
import { ProjectNameInput } from '../project-name-input/project-name-input.component';
import { ProjectRoomsWidget } from '../project-rooms-widget/project-rooms-widget.component';

export type CreateProjectContentProps = {
	projectCreated?: (projectId: number, projectName: string) => void;
	trackingPageName?: string;
};

export const CreateProjectContent: FunctionComponent<CreateProjectContentProps> = ({ projectCreated, trackingPageName }) => {
	const { loading, data, error } = useQuery<ProjectRoomsQuery, ProjectRoomsQueryVariables>(PROJECT_ROOMS, { fetchPolicy: 'cache-first' });
	const [selectedRooms, setSelectedRooms] = useState<number[]>([]);
	if (error) {
		logError(error.message, error);
	}

	const projectRooms = data?.projectRooms;
	const onProjectCreated = (projectId: number, projectName: string) => {
		if (projectCreated) {
			projectCreated(projectId, projectName);
		}
	};

	return (
		<>
			{loading ? (
				<Loading />
			) : (
				<>
					<ProjectRoomsWidget rooms={projectRooms} selectedRooms={selectedRooms} setSelectedRooms={setSelectedRooms} />
					<ProjectNameInput
						selectedRooms={selectedRooms}
						projectCreated={onProjectCreated}
						rooms={projectRooms}
						trackingPageName={trackingPageName}
						title="What is your project's name?"
						titleClassName="f5"
						containerClassName="ph4"
					/>
				</>
			)}
		</>
	);
};
